import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import Layout from "../../containers/Layout/Layout";
import { loadCompanyAction, getCompany } from "../../../state/trial";
import Loader from "../../atomic/Loader/Loader";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../atomic/Button/Button";
import Panel from "../../atomic/Panel/Panel";
import { withTheme } from "styled-components";
import { publishData } from "../../../appCalls";

const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const PublishPage = withTheme(({ theme }) => {
  const [saving, setSaving] = useState(false);
  const [published, setPublished] = useState(false);
  const company = useSelector(getCompany);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!company) {
      dispatch(loadCompanyAction());
    }
  }, []);
  if (!company) {
    return (
      <Layout>
        <Loader />
      </Layout>
    );
  }
  return (
    <Layout>
      <h1>Publish data</h1>
      <Panel>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "0px 0px 10px 0px"
          }}
        >
          Publish data to update your details in search.
        </div>
        <Buttons>
          {!saving && (
            <Button
              inverted
              onClick={async () => {
                setSaving(true);
                setPublished(true);
                await publishData(company.id);
                setSaving(false);
              }}
            >
              Publish
            </Button>
          )}
          {saving && (
            <Button inverted>
              <FontAwesomeIcon
                icon={["fas", "spinner"]}
                size="1x"
                color={theme.color5}
                spin
              />
            </Button>
          )}
        </Buttons>
      </Panel>
    </Layout>
  );
});

export default PublishPage;
